<mat-dialog-content>
    <div class="hypo-dialog-header">
        <div class="hypo-dialog-title">
            <mat-icon>trending_down</mat-icon>
            <div>
                Úprava výdaje
                @if (expenditureDialogForm.get('type').value) {
                    <span class="hidden md:inline">
                        ({{ expenditureDialogForm.get('type').value | option: ('expenditureType' | listByType) }})
                    </span>
                }
            </div>
        </div>

        <button mat-dialog-close type="button" [attr.data-testid]="'expenditure-dialog-button-close'">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <form [formGroup]="expenditureDialogForm" [attr.data-testid]="'expenditure-dialog'" class="hypo-dialog-content">
        <div appHasError #hasError="appHasError">
            <div class="flex flex-col">
                <div class="flex flex-col lg:flex-row gap-4">
                    <div class="basics w-full flex flex-col">
                        <h4>Základní údaje</h4>
                        <app-hypo-radio
                            [label]="'Typ výdaje'"
                            [listName]="'expenditureType'"
                            [toggleAbleOptions]="true"
                            [itemClass]="'max-md:w-full'"
                            formControlName="type">
                        </app-hypo-radio>
                        @if (type.value) {
                            <div class="flex flex-col xs:flex-row xs:gap-4">
                                @if ('payment' | shouldShowInput: expenditureConfig.showInputOnTypes : type.value) {
                                    <app-hypo-input
                                        class="w-full"
                                        [inputmode]="'decimal'"
                                        [label]="'Měsíční splátka'"
                                        [mask]="'separator.0'"
                                        [suffix]="'Kč'"
                                        formControlName="payment">
                                    </app-hypo-input>
                                }
                                @if ('balance' | shouldShowInput: expenditureConfig.showInputOnTypes : type.value) {
                                    <app-hypo-input
                                        class="w-full"
                                        [inputmode]="'decimal'"
                                        [label]="'Zůstatek'"
                                        [mask]="'separator.0'"
                                        [suffix]="'Kč'"
                                        [tooltip]="'Aktuální částka, která Vám zbývá na závazku doplatit.'"
                                        formControlName="balance">
                                    </app-hypo-input>
                                }
                                @if ('limit' | shouldShowInput: expenditureConfig.showInputOnTypes : type.value) {
                                    <app-hypo-input
                                        class="w-full"
                                        [label]="'Rámec'"
                                        [mask]="'separator.0'"
                                        [suffix]="'Kč'"
                                        [tooltip]="
                                            'Uveďte maximální schválený limit (i když produkt aktuálně nečerpáte).'
                                        "
                                        formControlName="limit">
                                    </app-hypo-input>
                                }
                            </div>
                        }
                    </div>

                    @if (showMore) {
                        <div class="details flex flex-col w-full">
                            <h4>Podrobnosti</h4>
                            <ng-container formGroupName="source">
                                <div class="flex flex-col">
                                    <app-hypo-radio
                                        [label]="'Typ poskytovatele'"
                                        [listName]="'creditorType'"
                                        formControlName="type">
                                    </app-hypo-radio>
                                </div>
                                <div class="flex flex-col">
                                    @if (sourceType.value === ExpenditureSourceTypeEnum.country) {
                                        <app-hypo-select
                                            [label]="'Stát'"
                                            [listName]="'country'"
                                            [tooltip]="'Vyberte stát, u kterého máte svůj závazek.'"
                                            formControlName="countryCode">
                                        </app-hypo-select>
                                    }
                                    @if (sourceType.value === ExpenditureSourceTypeEnum.bank) {
                                        <app-hypo-select
                                            [label]="'Banka'"
                                            [listName]="'bank'"
                                            [tooltip]="'Vyberte instituci, u které máte svůj závazek.'"
                                            formControlName="bankCode">
                                        </app-hypo-select>
                                    }
                                    @if (
                                        sourceType.value === ExpenditureSourceTypeEnum.nonBank ||
                                        sourceType.value === ExpenditureSourceTypeEnum.other
                                    ) {
                                        <app-hypo-input
                                            [inputmode]="'text'"
                                            [label]="'Název poskytovatele'"
                                            [tooltip]="'Uveďte instituci/subjekt, u které máte svůj závazek.'"
                                            formControlName="name">
                                        </app-hypo-input>
                                    }
                                </div>
                            </ng-container>
                        </div>
                    }
                </div>
            </div>
        </div>
    </form>

    <div class="hypo-dialog-footer">
        <button
            (click)="continue()"
            class="btn btn-lg orange expenditure-dialog-button-continue"
            mat-button
            type="button"
            [attr.data-testid]="'expenditure-dialog-button-continue'">
            Pokračovat
        </button>
    </div>
</mat-dialog-content>
